import { RoutingStep } from 'router/models/Routes';
import BuyerBrowsePortfolio from './pages/BuyerBrowsePortfolio';
import Watchlist from './pages/Watchlist';
import ListingPreviewBuyer from './subrouters/ListingPreviewBuyer';
import listingPreviewBuyerRoutes from './subrouters/ListingPreviewBuyer/routes';

export default [
  {
    index: true,
    element: BuyerBrowsePortfolio,
    labelId: 'browseListings',
    stepName: 'browseListings',
  },
  {
    path: 'watchlist',
    element: Watchlist,
    labelId: 'watchlist',
    stepName: 'watchlist',
  },
  {
    path: ':id',
    element: ListingPreviewBuyer,
    routes: listingPreviewBuyerRoutes,
    labelId: 'listing-preview-buyer',
    stepName: 'listing-preview-buyer',
  },
] as Array<RoutingStep>;
